export default __webpack_public_path__ + "static/media/cc_purple.0c3937aa.jpg";